"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _deviceMobile = _interopRequireDefault(require("@atlaskit/icon/core/device-mobile"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MobileIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm10 2H7v13h10zm-3 15h-4v1h4z" clip-rule="evenodd"/></svg>`
}, props, {
  newIcon: _deviceMobile.default
}));
MobileIcon.displayName = 'MobileIcon';
var _default = exports.default = MobileIcon;